<div class="filter-headline">
  <h2>Aktuelles –<br />bleiben Sie stets auf dem Laufenden.</h2>
  <h4>Bitte wählen Sie eine Kategorie:</h4>
</div>
<div class="filter-container">
  <hdi-filter
    [label]="'Alle'"
    [isSelected]="selectedFilter === 'Alle'"
    [hasCheckmark]="false"
    (clickEvent)="handleClick($event)"
  ></hdi-filter>
  <ng-container *ngIf="!caasFilters">
    <hdi-filter
      *ngFor="let filter of filters"
      [label]="filter | capitalize"
      [isSelected]="selectedFilter === filter"
      [hasCheckmark]="false"
      (clickEvent)="handleClick($event)"
    ></hdi-filter>
    <hdi-dropdown
      [type]="DropdownType.COMBOBOX_FILTER"
      [dropdownPlaceholder]="'Filter auswählen'"
      [itemList]="filtersMobile"
      (clickEvent)="handleClick($event)"
    ></hdi-dropdown>
  </ng-container>
  <ng-container *ngIf="caasFilters">
    <hdi-filter
      *ngFor="let filter of caasFilters"
      [label]="filter.filter | capitalize"
      [isSelected]="selectedFilterCaas?.filter === filter.filter"
      [hasCheckmark]="false"
      (clickEvent)="handleClick($event)"
    ></hdi-filter>
    <hdi-dropdown
      [type]="DropdownType.COMBOBOX_FILTER"
      [dropdownPlaceholder]="'Filter auswählen'"
      [itemList]="filtersMobile"
      (clickEvent)="handleClick($event)"
    ></hdi-dropdown>
  </ng-container>
</div>
